/*
 * MMM · Croix Protectrice : choix en deux étapes (29/09/2026). Voir snippets/mmm-croix-choix.liquid.
 * Tout l'état (pierre active, croix visibles, textes) est rendu par le serveur : à chaque changement de variante, le thème
 * remplace le bloc « liquid » qui contient le sélecteur. Ce script ne fait que :
 * 1. Clic sur une pierre (étape 1) : montre ses croix et coche la première disponible, ce qui change la variante.
 * 2. Barre d'achat collante (mmm-fiche.js, qui ramène au sélecteur tant que rien n'est choisi) : son libellé dit « Œil · croix · prix ».
 * Les écouteurs globaux sont posés une seule fois ; le choix de la cliente survit au remplacement du bloc.
 */
(() => {
  if (customElements.get('mmm-croix-choix')) return;
  const etat = { choisi: false, variant: null };
  const idDe = (el) => (el && el.getAttribute ? el.getAttribute('id') : null);
  const euros = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(c / 100);
  const actuel = () => document.querySelector('mmm-croix-choix');

  const marquerChoix = () => {
    etat.choisi = true;
    const sticky = document.querySelector('mmm-cta-sticky');
    if (sticky) sticky.choix = true;
  };

  // Barre collante : la combinaison sur une ligne (« Œil labradorite · croix rubis »), le bouton « Ajouter — €159,00 »
  // (prix au format du thème, lu sur la croix cochée).
  const majBarre = () => {
    const el = actuel(); if (!el) return;
    const p = el.querySelector('.mmm-croix__p[aria-pressed="true"]');
    const c = el.querySelector('.mmm-croix__item input:checked + label');
    if (!p || !c) return;
    const detail = 'Œil ' + p.dataset.nom.toLowerCase() + ' · croix ' + c.dataset.nom.toLowerCase();
    const prix = c.dataset.prix || (etat.variant && etat.variant.price != null ? euros(etat.variant.price) : '');
    document.querySelectorAll('.mmm-portail [data-mmm-detail]').forEach((d) => { d.textContent = detail; });
    document.querySelectorAll('.mmm-portail .mmm-sticky [data-mmm-libelle]').forEach((d) => { d.textContent = prix ? 'Ajouter — ' + prix : 'Ajouter au panier'; });
  };

  class MmmCroixChoix extends HTMLElement {
    connectedCallback() {
      if (etat.choisi) marquerChoix();
      try { etat.variant = JSON.parse(this.querySelector('script[data-variant]').textContent); } catch (e) { /* prix du serveur */ }
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-voir-photo]')) {
          const g = document.querySelector('product-gallery');
          if (g) window.scrollTo({ top: Math.max(0, g.getBoundingClientRect().top + window.scrollY - 70), behavior: 'smooth' });
          return;
        }
        const b = e.target.closest('.mmm-croix__p');
        if (!b) return;
        marquerChoix();
        const p = b.dataset.pierre;
        this.querySelectorAll('.mmm-croix__p').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
        const items = [...this.querySelectorAll('.mmm-croix__item')];
        items.forEach((it) => { it.hidden = it.dataset.pierre !== p; });
        const titre = this.querySelector('[data-choisi-pierre]'); if (titre) titre.textContent = b.dataset.nom;
        const sens = this.querySelector('[data-sens-pierre]'); if (sens) sens.textContent = b.dataset.sens ? b.dataset.nom + ' : ' + b.dataset.sens + '.' : '';
        const dela = items.find((it) => it.dataset.pierre === p && it.querySelector('input').checked);
        if (dela) return;
        const cible = items.find((it) => it.dataset.pierre === p && !it.querySelector('input').hasAttribute('data-epuise'))
          || items.find((it) => it.dataset.pierre === p);
        if (cible) cible.querySelector('input').click();
      });
      this.addEventListener('change', (e) => { if (e.isTrusted && e.target.matches('input[data-option-position]')) marquerChoix(); });
      setTimeout(majBarre, 0);
    }
  }
  customElements.define('mmm-croix-choix', MmmCroixChoix);

  // Barre collante : rien choisi → assets/mmm-fiche.js ramène au sélecteur, à chaque clic (01/10 : avant, un seul retour puis ajout).
  document.addEventListener('variant:change', (e) => {
    const el = actuel();
    if (!el || !e.target || idDe(e.target) !== el.dataset.formId || !e.detail || !e.detail.variant) return;
    etat.variant = e.detail.variant;
    setTimeout(majBarre, 0);
  });
  window.addEventListener('load', majBarre);
  document.addEventListener('mmm:etat', () => setTimeout(majBarre, 0));

  // 4. Bulle d'intention à côté de la bulle matière (bloc mmm_matiere, jamais re-rendu par le thème) : posée une fois.
  const poserIntention = () => {
    const el = actuel(); const txt = el && el.dataset.intention;
    const zone = document.querySelector('.product-info .mmm-matiere__badges');
    if (!txt || !zone || zone.querySelector('.mmm-croix__intention')) return;
    const b = document.createElement('b');
    b.className = 'mmm-matiere__badge mmm-croix__intention';
    b.textContent = txt;
    zone.appendChild(b);
  };

  const initPage = () => { if (!actuel()) return; poserIntention(); };  // galerie : assets/mmm-galerie-v.js (01/10)
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPage); else initPage();
  window.addEventListener('load', initPage);


  // 3. Ordinateur : « Complétez avec » (colonne d'achat) part à la hauteur de « L'histoire du collier » (sous la galerie).
  //    Sans « Le mot de Mathilde », l'alignement de mmm-fiche.js (section 11) ne s'applique pas. On n'ajoute que de l'espace,
  //    sur l'enveloppe du bloc (que mmm-fiche.js ne remet pas à zéro). Rien sous 1000 px.
  const aligner = () => {
    const gauche = document.querySelector('.product-content-below-gallery');
    const compl = document.querySelector('.product-info .mmm-compl');
    const env = compl && compl.closest('.product-info__block-item');
    if (!env || !gauche) return;
    env.style.paddingTop = ''; gauche.style.paddingTop = '';
    if (!window.matchMedia('(min-width: 1000px)').matches) return;
    const premier = [...gauche.children].find((x) => x.offsetHeight > 0);
    if (!premier) return;
    // On cale les titres eux-mêmes (« L'histoire du collier » ↔ « Complétez avec ») : on descend celui qui est le plus haut
    // (padding, que mmm-fiche.js ne remet pas à zéro) ; deux passes pour absorber les marges du thème.
    const titreG = premier.querySelector('h2, h3, .mmm-titre') || premier;
    const titreD = compl.querySelector('h2, h3, .mmm-titre') || compl;
    let pd = 0, pg = 0;
    for (let i = 0; i < 2; i++) {
      const d = titreG.getBoundingClientRect().top - titreD.getBoundingClientRect().top;
      if (Math.abs(d) < 0.5) break;
      if (d > 0) pd += d; else pg -= d;
      if (pd > 400 || pg > 400) { pd = 0; pg = 0; }
      env.style.paddingTop = pd ? pd + 'px' : '';
      gauche.style.paddingTop = pg ? pg + 'px' : '';
    }
  };
  let attente = false;
  const demander = () => { if (attente) return; attente = true; requestAnimationFrame(() => { attente = false; aligner(); }); };
  const initAligner = () => {
    if (!actuel()) return;
    const cols = [document.querySelector('.product-info'), document.querySelector('.product-content-below-gallery')].filter(Boolean);
    if (window.ResizeObserver) { const ro = new ResizeObserver(demander); cols.forEach((e) => ro.observe(e)); }
    window.addEventListener('resize', demander, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(demander);
    demander();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAligner); else initAligner();
  window.addEventListener('load', demander);
})();
